import { useQuery } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'

export interface StateFormData {
  state_config: {
    id?: string;
    // Colorado specific fields below
    is_employer_reimbursing_premium: boolean;
    is_employer_using_ichra: boolean;
    had_small_group_plan: boolean;
    marital_status: string;
    is_native_family: boolean;
    race_american_indian_alaska_native: boolean;
    race_asian_asianamerican: boolean;
    race_black_africanamerican: boolean;
    race_hispanic_latino: boolean;
    race_middle_eastern_north_african: boolean;
    race_native_hawaiian_pacific_islander: boolean;
    race_white_european: boolean;
    race_other: boolean;
    is_enrolled_in_medicaid: boolean;
    is_enrolled_in_medicare: boolean;
    race_other_description: string;
    race_decline_to_answer: boolean;
    has_current_medical_coverage: boolean;
    will_cancel_current_coverage: boolean;
    is_using_hra: boolean;
    hra_type?: string;
    is_replacing_coverage: boolean;
    current_coverages?: {
      covered_participant_id: string;
      coverage_type: string;
      coverage_start_date: string;
      coverage_end_date: string;
      carrier_name: string;
    }[];
    medicaid_participant_id?: string;
    medicare_participant_id?: string;
    medical_assistance_coverage_type?: string;
    replacement_coverage_reason?: string;
    replacement_coverage_custom_reason?: string;
    is_assisted_application: boolean;
    assistant_given_name?: string;
    assistant_family_name?: string;
    assistant_relationship?: string;
    use_paperless_notices: boolean;
    guardian_given_name?: string;
    guardian_family_name?: string;
    guardian_email?: string;
    guardian_address_line1?: string;
    guardian_address_line2?: string;
    guardian_city?: string;
    guardian_county?: string;
    guardian_state?: string;
    guardian_zip?: string;
    guardian_phone?: string;
    // New Jersey specific fields below
    has_other_residence: boolean;
    other_residence_duration_in_months?: number;
    other_residence_address_line1?: string;
    other_residence_address_line2?: string;
    other_residence_city?: string;
    other_residence_state?: string;
    other_residence_zip?: string;
    other_residence_country?: string;
    other_residence_phone?: string;
    // Georgia and Nevada
    has_no_dependent_children_under_19: boolean;
    has_pediatric_dental_coverage: boolean;
  };
  requires_guardian_info?: boolean; // only used for Colorado
}

export const useGetStateFormData = () => {
  return useQuery<StateFormData, GrapeAPIErrorType>({
    queryKey: ['stateFormData'],
    queryFn: async () => {
      const response = await fetch('/member_onboarding/embedded_state_form', { // eslint-disable-line thatch/no-bare-fetch
        headers: {
          Accept: 'application/json',
        },
      })

      // this isn't a Grape API, but we're going to use the same shape to simplify
      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
        })
      }

      return response.json()
    },
  })
}
